// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import acmDashboard from './slices/acmDashboard';
import bookingDetails from './slices/bookingDetails';
import newBookingDetails from './slices/newBookingDetails';
import bookingList from './slices/bookingList';
import bookingRequests from './slices/bookingRequests';
import calendarReducer from './slices/calendar';
import cartReducer from './slices/cart';
import chatReducer from './slices/chat';
import commonSearch from './slices/commonSearch';
import contactReducer from './slices/contact';
import customerReducer from './slices/customer';
import internalCommenting from './slices/internalCommenting';
import kanbanReducer from './slices/kanban';
import mailReducer from './slices/mail';
import memberDetails from './slices/memberDetails';
import memberList from './slices/memberList';
import memberPriority from './slices/memberPriority';
import menuReducer from './slices/menu';
import moduleAccess from './slices/moduleAccess';
import ticketsList from './slices/openCloseTickets';
import pendingBooking from './slices/pendingBooking';
import productReducer from './slices/product';
import quoteDetails from './slices/quotes';
import reqComments from './slices/reqComments';
import requirementFunnel from './slices/requirementFunnel';
import snackbarReducer from './slices/snackbar';
import userReducer from './slices/user';
import onTripAnnouncement from './slices/onTripAnnouncement';
import aiLogs from './slices/aiLogs';
import hhiHotelList from './slices/hhiHotelList';
import hhiRoomsList from './slices/hhiRoomsList';
import queuesnackbar from './slices/queueSnackBar';
import coupons from './slices/coupons';
import linkedBooking from './slices/linkedBooking';
import transfers from './slices/transfers';
import onTripSurvey from './slices/OnTripSurvey';
import quotesPageGenerateItinerary from './slices/quotesPageGenerateItinerary';
import refreshElastic from './slices/refreshElastic';
import agentProfile from './slices/agentProfile';
import userTicketSectionReducer from './slices/userAssignmentTicketSectionSlice';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    acmDashboard,
    memberList,
    memberDetails,
    bookingList,
    reqComments,
    memberPriority,
    requirementFunnel,
    ticketsList,
    quoteDetails,
    commonSearch,
    bookingRequests,
    bookingDetails,
    internalCommenting,
    moduleAccess,
    pendingBooking,
    onTripAnnouncement,
    aiLogs,
    hhiHotelList,
    hhiRoomsList,
    queuesnackbar,
    coupons,
    linkedBooking,
    transfers,
    onTripSurvey,
    quotesPageGenerateItinerary,
    refreshElastic,
    agentProfile,
    newBookingDetails,
    userTicketSectionReducer
});

export default reducer;
